import { DataGridPro } from '@cibo/ui'
import { GridCellParams, GridColDef, GridColumnHeaderParams, GridValidRowModel, MuiEvent } from '@mui/x-data-grid-pro'
import { KeyboardEvent } from 'react'

const TRAIT_GRID_SX = {
  '.MuiDataGrid-columnHeaders': { fontSize: '16px' },
  '.MuiDataGrid-columnHeaderTitle': { fontWeight: '400' },
  '.MuiDataGrid-row:hover': { backgroundColor: 'rgba(24, 48, 56, 0.03)' },
  '.MuiDataGrid-row:hover .MuiDataGrid-cell--pinnedLeft': { backgroundColor: 'unset' },
  '.MuiDataGrid-cell--pinnedLeft': {
    borderRight: '1px solid rgba(224, 224, 224, 1)',
    boxShadow: '2px 0px 4px -2px #00000036',
  },
  '.cell--copied': {
    outline: '2px dashed',
    outlineColor: 'primary.main',
    outlineOffset: '-2px',
  },
}

interface TraitDataGridProps {
  rows: GridValidRowModel[]
  columns: GridColDef[]
  hideFooter?: boolean
  apiRef?: any
  onCellKeyDown?: (params: GridCellParams, event: MuiEvent<KeyboardEvent>) => void
  getCellClassName?: (params: GridCellParams) => string
  onColumnHeaderClick?: (params: GridColumnHeaderParams, event: any) => void
}

export const TraitDataGrid = ({
  rows,
  columns,
  hideFooter,
  apiRef,
  onCellKeyDown,
  getCellClassName,
  onColumnHeaderClick,
}: TraitDataGridProps) => (
  <DataGridPro
    apiRef={apiRef}
    getRowHeight={() => 'auto'}
    rows={rows}
    columns={columns}
    hideFooter={hideFooter}
    initialState={{ pinnedColumns: { left: ['traitId'] } }}
    sx={TRAIT_GRID_SX}
    onCellKeyDown={onCellKeyDown}
    getCellClassName={getCellClassName}
    onColumnHeaderClick={onColumnHeaderClick}
  />
)
